/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = "is-active";
	const v = "is-visible";
	const _pagepath = "/blog/";

	const blogCategory = () => {
		const blogCatWraps = document.querySelectorAll(".js-blog-cat-wrap");
		const blogTagWraps = document.querySelectorAll(".js-blog-tag-wrap");

		blogCatWraps.forEach((wrap) => {
			const blogCat = wrap.querySelector(".js-blog-cat");

			if (!blogCat || blogCat.textContent.trim() !== "blog_category") {
				wrap.remove();
			}
		});

		blogTagWraps.forEach((wrap) => {
			const blogTag = wrap.querySelector(".js-blog-tag");

			if (!blogTag || blogTag.textContent.trim() !== "blog_category2") {
				wrap.remove();
			}
		});
	};

	blogCategory();
})(window.FUNCTIONS);
